import React, { useEffect } from 'react';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import Footer from '../../components/Footer/Footer';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';
import DestinationsMapFixed from '../../components/BrandHomePage/DestinationsMap/DestinationsMapFixed';
import AccommodationsList from '../../components/AccommodationsList/AccommodationsList';
import { useOverlayManager } from '../../contexts/OverlayContext';
import { initializeAllFeatures } from '../../utils/interactiveFeatures';
import { images } from '../../components/shared/assets';
import '../../styles/property-pages.css';

const AccommodationsMendoza: React.FC = () => {
  const { setHoveredDestination } = useOverlayManager();

  useEffect(() => {
    initializeAllFeatures();
    setHoveredDestination(null);
  }, [setHoveredDestination]);

  // CORRECTED TO MATCH APPROVED PROPERTY MAP EXACTLY
  const accommodations = [
    {
      id: 'luxury-front-row-rooms',
      title: 'Luxury and Front Row Rooms',
      description: 'All have king size and twin beds, a large master bath and dual vanities. The bedroom connects to a separate indoor living room. 90 mt (970 sq. feet) of inside/outside living space.',
      images: [images.villas13, images.masterVilla, images.villaExterior],
      ctaLink: '/contact',
      detailsLink: '/contact'
    },
    {
      id: 'vineyard-villa',
      title: 'Vineyard Villa',
      description: 'With 2,200 square feet of indoor-outdoor living space, our 2 Vineyard Villas offer an upscale lodge experience like no other.',
      images: [images.masterVilla, images.villas13, images.villaInterior],
      ctaLink: '/contact',
      detailsLink: '/contact'
    },
    {
      id: 'one-bedroom-villa',
      title: 'One Bedroom Villa',
      description: 'Master bedroom suite with oversized bath with double vanity. For extra privacy there are two WCs and two showers.',
      images: [images.villaExterior, images.masterVilla, images.villas13],
      ctaLink: '/contact',
      detailsLink: '/contact'
    },
    {
      id: 'grand-villa',
      title: 'Grand Villa',
      description: 'Idyllic for couples and families with grown up children, the Grand Villa offers a wonderfully spacious and accommodating home away from home.',
      images: [images.masterVilla, images.villaInterior, images.villaExterior],
      ctaLink: '/contact',
      detailsLink: '/contact'
    }
  ];

  // CORRECTED TO MATCH APPROVED PROPERTY MAP EXACTLY
  const communalAreas = [
    {
      title: "Relais & Châteaux Restaurant",
      description: "Channeling an authentic 'farm-to-table' concept, Mendoza's chef creates cuisine using organic products harvested from the restaurant's own gardens. In addition to finding remarkable food and wine pairings, he shares his expertise at culinary workshops."
    },
    {
      title: "Living-room",
      description: "Living-room offering a comforting and relaxed atmosphere, surrounded by books and fireplaces"
    },
    {
      title: "Board room available in an area inside the cellar",
      description: "" // Approved but no description provided in property map
    },
    {
      title: "Gift Shop",
      description: "" // Approved but no description provided in property map
    }
  ];

  return (
    <div className="property-page">
      {/* Navigation */}
      <UnifiedNavigation variant="light" destination="mendoza" />
      
      {/* Accommodations List Component */}
      <AccommodationsList
        variant="mendoza"
        heroTitle="Respecting nature and ancient buildings techniques" // CORRECTED TO APPROVED TITLE
        heroImage={images.mendozaHero || images.video1}
        subheaderText="Nestled in a 55 acre vineyard, Awasi Mendoza is a room property strategically located between the best known wineries and the magnificent Andes Mountain range. The exclusive rooms & villas are free-standing, with natural comfortable exteriors and relaxed décor." // CORRECTED TO APPROVED COPY
        accommodations={accommodations}
        communalAreas={communalAreas}
        communalAreasImage={images.restaurantFeature}
        fullLandscapeImage={images.producingNaturePage.fullDesertLandscape}
      />

      {/* Map Section */}
      <section className="mendoza-map-wrapper" style={{ background: 'var(--color-off-white)', padding: '80px 0' }}>
        <DestinationsMapFixed />
      </section>

      {/* Instagram Section */}
      <InstagramSection 
        title="Follow us on Instagram @awasiexperience"
        posts={[
          { src: images.film13, alt: "Instagram 1" },
          { src: images.filmVideo1, alt: "Instagram 2", isVideo: true },
          { src: images.film14, alt: "Instagram 3" },
          { src: images.film15, alt: "Instagram 4" }
        ]}
      />

      {/* Footer */}
      <Footer variant="mendoza" />
    </div>
  );
};

export default AccommodationsMendoza;